export default "__VITE_ASSET__DZWXUNXo__"